import React, {useEffect} from 'react'
import {useForm} from "react-hook-form";
import Card from "../../../components/forms/Card";
import FormGroup from "../../../components/forms/FormGroup";
import Button from "../../../components/forms/Button";
import ConsejeriasFormSelect from "../../../components/selects/ConsejeriasFormSelect";
const ConsejeriaRiskForm = ({value, onSubmit}) => {

  const {register, handleSubmit, formState: {errors}, reset} = useForm(
    {defaultValues: value}
  );

  useEffect(() => {
    if (value) {
      reset(value)
    }
  }, [value])

  return (
    <form>
      <Card padding>

        <FormGroup>
          <label>Consejeria a relacionar</label>
          <ConsejeriasFormSelect {...register("id", {required: "Campo obligatorio"})}/>
          {errors.id && <p style={{color: 'red'}}>{errors.id?.message}</p>}
        </FormGroup>

      </Card>

      <Button variant={'primary'} onClick={handleSubmit(onSubmit)}>Guardar</Button>
    </form>
  )
}

export default ConsejeriaRiskForm;
